import { useMutation } from 'react-query';
import type { AxiosResponse, AxiosError } from 'axios';
import type { TMutation } from '../types';
import { logoff } from './requests';
import type { TPostLogoutResponse } from './types';

export const mutationLogout = ({
    onSuccess,
    onError,
}: TMutation<TPostLogoutResponse>) => useMutation<
    AxiosResponse<TPostLogoutResponse>,
    AxiosError,
    string
>({
    mutationFn: logoff,
    onSuccess: (resp) => {
        if (onSuccess) {
            onSuccess(resp.data);
        }
    },
    onError: () => {
        if (onError) {
            onError();
        }
    },
});
